import React, { Component } from 'react'

// ui
import { FaEdit, FaTrashAlt } from 'react-icons/fa'

// button
import Button from '../../components/uielements/button'
import { Menu, Dropdown, Col, Tag, Row, Tooltip, Checkbox } from 'antd'

// redux
import { connect } from 'react-redux'
import objectActions from '../../redux/component_select_object/actions'
import defaulObject from '../../resource/image/objectDefault.png'
class ObjectComponent extends Component {
    _handleDetailClick = () => {
        const { object } = this.props
        this.props.updateCurrentObject(object)
        this.props.showModalCurrentObjectInfo()
    }

    _handleDeleteClick = () => {
        const { object } = this.props
        this.props.updateCurrentObject(object)
        this.props.showModalConfirmDeleteObject()
    }

    _handleUpdateCurrentObject = () => {
        const { object } = this.props
        this.props.updateSelectObjectState(object.object_id, !object.isSelect)
    }

    render() {
        const { object } = this.props
        const { isSelect } = object
        const color = isSelect ? 'lightgreen' : 'white'

        return (
            <Col className="ObjectContainer" md={6} lg={6} xs={8} xxl={6}>
                <div
                    className="ObjectComponent"
                    style={{ backgroundColor: color }}
                    onClick={() => this._handleUpdateCurrentObject()}
                >
                    <Tooltip placement="top" title={object.name}>
                        <div className="AvatarImage">
                            <img
                                src={
                                    object.avatar !== ''
                                        ? object.avatar
                                        : defaulObject
                                }
                                alt="avatar"
                                style={{ objectFit: 'cover' }}
                            />
                        </div>
                        <div className="ObjectBody">
                            <Row
                                className="ListTag"
                                style={{ height: '1.5em !important' }}
                            >
                                <div className="ObjectName">{object.name}</div>
                            </Row>
                        </div>
                        <Row className="ObjectAction">
                            <Col md={12}>
                                <Button
                                    style={{ backgroundColor: '#b3e6ff' }}
                                    onClick={() => this._handleDetailClick()}
                                >
                                    <FaEdit />
                                    Chi tiết
                                </Button>
                            </Col>
                            <Col md={12}>
                                <Button
                                    style={{ backgroundColor: '#ff9999' }}
                                    onClick={() => this._handleDeleteClick()}
                                >
                                    <FaTrashAlt />
                                    Xoá
                                </Button>
                            </Col>
                        </Row>
                    </Tooltip>
                </div>
            </Col>
        )
    }
}

const mapStateToProps = state => {
    return {}
}

const mapDispatchToProps = dispatch => {
    return {
        showModalConfirmDeleteObject: () => {
            dispatch(objectActions.action.showModalConfirmDeleteObject())
        },
        showModalCurrentObjectInfo: () => {
            dispatch(objectActions.action.showModalCurrentObjectInfo())
        },
        updateCurrentObject: object => {
            dispatch(objectActions.action.updateCurrentObject(object))
        },
        updateSelectObjectState: (oid, selectState) => {
            dispatch(
                objectActions.action.updateSelectObjectState(oid, selectState)
            )
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ObjectComponent)
